import React from 'react';
import { useExperiment } from './Experiment';
const Variant = ({ name, children }) => {
    const { variant } = useExperiment();
    if (variant === name)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(React.Fragment, null);
};
export default Variant;
